import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const without = ['One video per symptom, per brand — you still piece the order together', 'The OEM manual gives specs, not which test to run first', 'Parts-first guessing: carb, pump, plugs, then hope', 'Nothing for the counter: estimates, pickup, unclaimed equipment', 'Every new tech starts from zero and asks you'];
const withIt = ['161 Bench Cards by symptom and machine', 'The same 4 Gates on every machine, 2- and 4-stroke', 'PASS/FAIL at every step, and what to do when it fails', 'Repair order, estimate and pickup notice ready to print', 'A fast version for experienced techs, a guided one for new techs'];
export function ValueStack() {
  return <section aria-labelledby="vs-heading" className="topo-light w-full bg-paper" data-id="element-378" data-mp="2d798m7gj9148">
      <div className="mx-auto max-w-4xl px-5 py-14 sm:py-20" data-id="element-379" data-mp="30xbx6dl8noy3">
        <div className="text-center" data-id="element-380" data-mp="35ov2a7u7hh1f">
          <p className="eyebrow text-ember-deep" data-id="element-381" data-mp="35pwqle08g013">
            Why this isn&apos;t another repair video
          </p>
          <h2 id="vs-heading" className="trail-underline mt-3 font-display text-[34px] uppercase leading-tight text-pine sm:text-6xl" data-id="element-382" data-mp="1tfwi8ox0ukey">
            Free videos vs{' '}
            <span className="text-ember-deep" data-id="element-383" data-mp="236halum3qspf">a bench system</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-pine-soft" data-id="element-384" data-mp="1ydo7fb6a7sfg">
            Yes, there are thousands of repair videos online, and you have the
            manufacturer&apos;s manual. Information was never the hard part —
            knowing what to test next, in what order, when the obvious fix
            didn&apos;t work is. That&apos;s the part this does for you, and
            then it handles the counter too.
          </p>
        </div>

        <div className="mt-8 grid grid-cols-2 overflow-hidden rounded-2xl border border-paper-dark shadow-card" data-id="element-385" data-mp="rprb0uc6oz4s">
          <div className="bg-signal px-3.5 py-4 text-white sm:p-6" data-id="element-386" data-mp="mrg00ga5kikz">
            <span className="font-display text-3xl uppercase leading-none sm:text-4xl" data-id="element-387" data-mp="mt9ay7rstoys">
              Videos
            </span>
            <p className="mt-1 text-[10px] font-bold uppercase tracking-widest text-white/85 sm:text-[11px]" data-id="element-388" data-mp="2rrqvswlweyj3">
              Online clips &amp; manuals
            </p>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-389" data-mp="2vw6ykp07tpu3">
              {without.map(item => <li key={item} className="flex items-start gap-2 text-[13px] leading-snug text-white/95 sm:text-sm" data-id="element-390" data-mp="30qufo2sw3hyn">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-white/20" data-id="element-391" data-mp="3aptn5i1x57k2">
                    <XIcon className="h-2.5 w-2.5 text-white" aria-hidden="true" data-id="element-392" data-mp="3fjxyedi7w1qy" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="bg-forest px-3.5 py-4 text-white sm:p-6" data-id="element-393" data-mp="3ogez0msygh8g">
            <span className="font-display text-3xl uppercase leading-none sm:text-4xl" data-id="element-394" data-mp="3tie3y14cfm7i">
              Bench Cards
            </span>
            <p className="mt-1 text-[10px] font-bold uppercase tracking-widest text-ember sm:text-[11px]" data-id="element-395" data-mp="7e2fmhv7c9ad">
              Small Engine Diagnostic Pro
            </p>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-396" data-mp="3to4yssumr2qu">
              {withIt.map(item => <li key={item} className="flex items-start gap-2 text-[13px] font-medium leading-snug sm:text-sm" data-id="element-397" data-mp="3pmtijdxnbtvb">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-moss" data-id="element-398" data-mp="l7torp50tr5k">
                    <CheckIcon className="h-2.5 w-2.5 text-white" aria-hidden="true" data-id="element-399" data-mp="ggbqj8udu4oa" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}